<script>
import routerName from "@/router/routeNames";

export default {
  name: "AppPublicFooter",
  data() {
    return {
      routerName
    }

  }
}
</script>

<template>
  <footer class="rrd-footer mt-auto">
    <div class="rrd-footer-inner d-flex align-items-center">
      <div class="rrd-social mr-3">
        <!-- Ako koristiš Font Awesome, ovo će biti identično;
             u suprotnom možeš zamijeniti ikonice tekstom ili SVG-om -->
        <a href="#" class="rrd-social-link"><i class="fab fa-facebook-f"></i></a>
        <a href="#" class="rrd-social-link"><i class="fab fa-x-twitter"></i></a>
        <a href="#" class="rrd-social-link"><i class="fab fa-instagram"></i></a>
        <a href="#" class="rrd-social-link"><i class="fab fa-youtube"></i></a>
        <a href="#" class="rrd-social-link"><i class="fab fa-linkedin-in"></i></a>
        <a href="#" class="rrd-social-link"><i class="fab fa-tiktok"></i></a>
      </div>
      <div class="rrd-footer-text">
        <router-link
          :to="{ name: routerName.RN_PRIVACY_POLICY }"
          class="rrd-privacy-link"
        >
          Privacy Policy
        </router-link>
      </div>
      <div class="rrd-footer-text">
        Copyright © 2025 Regional Cooperation Council | Developed by Odavic
      </div>
    </div>
  </footer>
</template>

<style scoped>
.rrd-privacy-link {
  display: inline-block;
  margin-right: 1rem;
  font-size: 14px;
  color: #008fd5;
  text-decoration: none;
  transition: color 0.15s ease;
}

.rrd-privacy-link:hover {
  opacity: 0.6;
  text-decoration: underline;
}

</style>
